import { FunctionComponent, useEffect, useState, useRef } from 'react';
import styles from './Medications.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/pro-regular-svg-icons';
import { Switch } from 'components/UI/V3/Forms/Switch';
import MedicationComponent from './MedicationComponent';
import { Medication } from 'model/NewMultipleBooking';
import { Moment } from 'moment-timezone';

interface Props {
    isActive: boolean;
    medication: Medication;
    index: number;
    from?: Moment | undefined;
    to?: Moment | undefined;
    flow: 'boarding' | 'daycare';
    onUpdate: (index: number, medication: Medication) => void;
    onDelete: (index: number) => void;
    onActivate: (isActive: boolean) => void;
    onSetMedicationType: (index: number, type: string) => void;
    onHasAlerts?: (hasAlerts: boolean) => void;
}

export const Medications: FunctionComponent<Props> = ({
    isActive,
    medication,
    index,
    from,
    to,
    flow,
    onUpdate,
    onDelete,
    onActivate,
    onSetMedicationType,
    onHasAlerts
}) => {
    const [medicationState, setMedicationState] = useState<Medication>(medication);
    const prevMedicationProp = useRef(medication);

    const medicationType =
        medicationState.specificSchedule && medicationState.specificSchedule.length > 0 ? 'specific' : 'daily';

    useEffect(() => {
        if (prevMedicationProp.current !== medication) {
            prevMedicationProp.current = medication;
            setMedicationState(medication);
        }
    }, [medication]);

    useEffect(() => {
        const stateJson = JSON.stringify(medicationState);
        const propJson = JSON.stringify(medication);
        if (stateJson !== propJson) {
            onUpdate(index, medicationState);
        }
    }, [medicationState]);

    return (
        <div className={styles.medicationCard}>
            <div className={styles.cardHeader}>
                <div className={styles.cardTitle}>
                    <h4 className={styles.toggleSwitch}>Medication {isActive ? index + 1 : ''}</h4>
                    {index === 0 && (
                        <Switch
                            checked={isActive}
                            onChange={() => onActivate(!isActive)}
                        />
                    )}
                </div>
                {isActive && (
                    <div className={styles.deleteButton}>
                        <FontAwesomeIcon
                            icon={faTrashAlt}
                            onClick={() => onDelete(index)}
                        />
                    </div>
                )}
            </div>
            {isActive && (
                <MedicationComponent
                    medicationState={medicationState}
                    setMedicationState={setMedicationState}
                    index={index}
                    from={from}
                    to={to}
                    flow={flow}
                    medicationType={medicationType}
                    onSetMedicationType={onSetMedicationType}
                    onHasAlerts={onHasAlerts}
                />
            )}
        </div>
    );
};

export default Medications;
